var axios = require('axios');
var fieldManager = require('@managers/fieldManager');
var sensorsManager = require('@managers/sensorsManager');

const SCIROOT_FARMING_UNIT_PATH = 'farming_unit';

export var create_farming_unit = (distribution_id, farming_unit_obj) => {
  return new Promise(function (resolve, reject) {
    axios
      .post(SCIROOT_FARMING_UNIT_PATH + '/' + distribution_id, {
        farming_unit: farming_unit_obj,
      })
      .then(function (res) {
        resolve('');
      })
      .catch(function (e) {
        console.log(e.message);
        reject(e);
      });
  });
};

export var update_farming_unit = (distribution_id, farming_unit_obj) => {
  return new Promise(function (resolve, reject) {
    axios
      .put(
        SCIROOT_FARMING_UNIT_PATH +
          '/' +
          distribution_id +
          '/' +
          farming_unit_obj.id,
        {
          farming_unit: farming_unit_obj,
        }
      )
      .then(function (res) {
        resolve('');
      })
      .catch(function (e) {
        console.log(e.message);
        reject(e);
      });
  });
};

export var delete_farming_unit = (distribution_id, farming_unit_id) => {
  return new Promise(function (resolve, reject) {
    axios
      .delete(
        SCIROOT_FARMING_UNIT_PATH +
          '/' +
          distribution_id +
          '/' +
          farming_unit_id,
        {}
      )
      .then(function (res) {
        resolve('');
      })
      .catch(function (e) {
        console.log(e.message);
        reject(e);
      });
  });
};

export var loadFarmingUnitHistory = (
  distribution_id,
  farming_unit_id,
  field_id
) => {
  return new Promise(function (resolve, reject) {
    axios
      .get(
        SCIROOT_FARMING_UNIT_PATH +
          '/' +
          distribution_id +
          '/' +
          farming_unit_id,
        {
          farming_unit_id: farming_unit_id,
          distribution_id: distribution_id,
        }
      )
      .then(function (res) {
        resolve({ historicalData: res.data, farming_unit_id: farming_unit_id });
      })
      .catch(function (e) {
        console.log(e.message);
        reject(e);
      });
  });
};

export var all_farming_unit_areas = (
  farming_unit,
  selected_field_id,
  fieldsState = 'active'
) => {
  // Skeleton farming units omit `fields` until the full distribution tree loads.
  if (!farming_unit?.fields) {
    return {};
  }

  var all_areas_dictionary = {};

  for (var field_id in farming_unit.fields) {
    let currentField = farming_unit.fields[field_id];

    if (currentField.settings.field_state != fieldsState) {
      continue;
    }

    let fieldItems = fieldManager.getFieldItems(currentField);

    var field_stress_level = fieldItems.stressDataItem.value;
    var field_stress_color = fieldManager.get_stress_color(field_stress_level);

    all_areas_dictionary[field_id] = {
      areas: farming_unit.fields[field_id].geo_data.areas,
      title: farming_unit.fields[field_id].name,
      selected: field_id == selected_field_id,
      fill_color: field_stress_color,
    };
  }

  return all_areas_dictionary;
};

export var all_farming_unit_markers = (
  farming_unit,
  selected_field_id,
  fieldsState = 'active'
) => {
  // Skeleton farming units omit `fields` until the full distribution tree loads.
  if (!farming_unit?.fields) {
    return {};
  }

  var all_markers_dictionary = {};

  for (var field_id in farming_unit.fields) {
    let currentField = farming_unit.fields[field_id];

    if (currentField.settings.field_state != fieldsState) {
      continue;
    }

    var markers = {};

    for (var sensor_id in currentField.sensors) {
      const sensor = currentField.sensors[sensor_id];
      var current_sensor_coordinates = sensor.coordinates;
      const sensorType = (sensor?.type || '').toLowerCase();

      const wpSensorIds = Object.keys(currentField.sensors)
        .filter(id => sensorsManager.isWPSensor(currentField.sensors[id]))
        .sort();
      const sensorIndex = wpSensorIds.indexOf(sensor_id);

      let current_sensor_color;
      let displayName = '';
      let type = '';
      if (sensorType === 'piezometer') {
        current_sensor_color = '#FFFFFF';
        displayName = 'Piezometer Sensor';
        type = sensor.type;
      } else if (sensorType === 'wfr' || sensorType === 'pulse') {
        current_sensor_color = '#FFFFFF';
        displayName = 'Flow Meter Sensor';
        type =
          (sensor.manufacturer || '') +
          (sensor.sub_type ? ' ' + sensor.sub_type : '');
      } else if (
        sensorType === 'high_pressure' ||
        sensorType === 'low_pressure'
      ) {
        current_sensor_color = '#1565C0';
        type = sensor.type;
      } else if (sensorsManager.isWPSensor(sensor)) {
        current_sensor_color = sensorsManager.sensorColorByIndex(
          sensorIndex,
          fieldsState === 'archive' ? 'archive' : undefined
        );
        displayName = 'Sensor ' + (sensor.name || '');
        type = sensor.type;
      }

      if (
        current_sensor_coordinates.latitude != null &&
        current_sensor_coordinates.longitude != null &&
        current_sensor_coordinates.latitude != '' &&
        current_sensor_coordinates.longitude != ''
      )
        markers[sensor_id] = {
          coordinates: [
            sensor.coordinates.latitude,
            sensor.coordinates.longitude,
          ],
          info: displayName,
          color: current_sensor_color,
          transmitter_id: sensor.transmitter_id,
          type: type,
          // Raw sensor type code (e.g. 'wfr', 'piezometer'), distinct from
          // `type` above which is a display-oriented string that for
          // wfr/pulse sensors is composed as "manufacturer sub_type" (e.g.
          // "Tal-gil X1") rather than the code a sensorsMap-style lookup
          // expects. Consumers that need the real type code (not a display
          // string) should read this instead of `type`.
          sensor_type: sensor.type,
        };
    }

    if (markers && Object.keys(markers).length > 0)
      all_markers_dictionary[field_id] = {
        markers: markers,
        selected: String(field_id) === String(selected_field_id),
      };
  }

  return all_markers_dictionary;
};

export var shouldDisplayAllSensors = farmingUnit => {
  if (farmingUnit) {
    if (farmingUnit.settings.sensor_display == 'selected_only') {
      return false;
    }
  }

  return true;
};

export var shouldDisplayPlanner = farmingUnit => {
  // Skeleton farming units omit `fields` until the full distribution tree loads.
  if (farmingUnit?.fields) {
    for (const field_id in farmingUnit.fields) {
      if (farmingUnit.fields[field_id].settings.is_rolling_fit_active)
        return true;
    }
  }

  return false;
};

export var is_moderator = farmingUnit => {
  if (farmingUnit) {
    return farmingUnit.role === userRoles.MODERATOR;
  }
  return false;
};

/**
 * Determines if the week should start with Monday based on the farming unit's country.
 * If a farmingUnit object is provided, checks farmingUnit.country for 'Israel'.
 * If not, falls back to the old distributionName logic (deprecated).
 * @param {Object} [farmingUnit] - The farming unit object (preferred).
 * @param {string} [distributionName] - The distribution name (deprecated).
 * @returns {boolean} - True if week should start with Monday, false otherwise.
 */
export function shouldWeekStartWithMonday(farmingUnit, distributionName) {
  if (farmingUnit && typeof farmingUnit === 'object') {
    // Prefer farmingUnit.country if available
    if (farmingUnit.country) {
      return farmingUnit.country !== 'Israel';
    }
  }
  // Deprecated: fallback to distributionName logic
  if (distributionName) {
    return !(distributionName.includes('Israel') || distributionName === 'ABC'); // dev
  }
  return false;
}
